import { Component, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { QuotationDetailEnums } from 'src/app/enum/quotation-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { QuotationDetailModel } from 'src/app/models/preliminaries/quotation-detail.model';
import { QuotationVersionModel } from 'src/app/models/preliminaries/quotation-version.model';
import { QuotationModel } from 'src/app/models/preliminaries/quotation.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { BreakdownService } from 'src/app/services/preliminaries/breakdown.service';
import { QuotationDetailService } from 'src/app/services/preliminaries/quotation-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { ImportBreakdownComponent } from '../../breakdown/import-breakdown/import-breakdown.component';
import { AttachImagesQuotationDetailComponent } from '../attach-images-quotation-detail/attach-images-quotation-detail.component';
import { CopyQuotationComponent } from '../copy-quotation/copy-quotation.component';
import { DetailFromCompositeArticleComponent } from '../detail-from-composite-article/detail-from-composite-article.component';
import { UnitCode } from 'src/app/constants/unit-code-constants';

@Component({
  selector: 'app-new-register-quotation-detail',
  templateUrl: './new-register-quotation-detail.component.html',
  styleUrls: ['./new-register-quotation-detail.component.scss'],
  standalone: false
})
export class NewRegisterQuotationDetailComponent implements OnInit {
  private readonly breakdownService = inject(BreakdownService);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly formControlStateService = inject(FormControlStateService);
  private readonly optionWindowService = inject(OptionWindowService);
  private readonly quotationSolutionService = inject(QuotationDetailService);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);

  @ViewChild('copyQuotation') copyQuotationModalComponent?: CustomModalComponent | null = null;
  @ViewChild('importBreakdown') importModalComponent?: CustomModalComponent | null = null;
  @ViewChild('compositeArticle') compositeArticleModalComponent?: CustomModalComponent | null = null;
  @ViewChild('attachImages') attachImagesModalComponent?: CustomModalComponent | null = null;

  @Input() permissionUpdatable: boolean = false;
  @Input('quotationContract') set quotation(change: QuotationModel) {
    this.changeQuotation(change);
  }
  @Input('quotationVersion') set quotationVersion(change: QuotationVersionModel) {
    this.changeQuotationVersion(change);
  }
  @Input('quotationDetailContract') set quotationSolution(change: QuotationDetailModel) {
    this.changeQuotationSolutionContract(change);
  }

  @Input('updateFormDetail') set updateFormDetail(change: boolean) {
    this.getQuotationDetailsByVersion();
  }
  @Output() updateQuotationDetail = new EventEmitter<boolean>();

  breakdownsInSolution: boolean = false;
  breakpointsForImport: { [key: string]: string } = {
    '1024px': '50vw',
    '768px': '60vw',
    '560px': '90vw'
  };

  componentCopyQuotation = CopyQuotationComponent;
  componentImportBreakdown = ImportBreakdownComponent;
  componentCompositeArticle = DetailFromCompositeArticleComponent;
  componentAttachImages = AttachImagesQuotationDetailComponent;
  formQuotationSolution: FormGroup = new FormGroup({});
  selectedQuotationDetail: QuotationDetailModel = new QuotationDetailModel();
  quotationSolutionContract: QuotationDetailModel = new QuotationDetailModel();
  quotationDetails: QuotationDetailModel[] = [];
  inputsForCopy$ = new BehaviorSubject<any>({
    quotationVersion: QuotationVersionModel,
    quotationType: 0
  });
  inputsForImport$ = new BehaviorSubject<any>({
    quotationSolutionModel: QuotationDetailModel,
    breakdownsInSolution: false
  });
  inputsForMasterSolution$ = new BehaviorSubject<any>({
    quotationSolutionModel: QuotationDetailModel,
    quotationVersionId: null
  });
  inputsForAttachImages$ = new BehaviorSubject<any>({
    quotationSolutionModel: QuotationDetailModel,
  });
  outputImport$ = new Subject<any>();
  outputCopy$ = new Subject<any>();
  outputMasterSolution$ = new Subject<any>();
  outputAttachImages$ = new Subject<any>();
  listUnits: any[] = [];
  listCostCenters: any[] = [];
  listBaseValue: any[] = [];
  permissionsUser: OptionWindowModel[] = [];
  subscription: Subscription;
  quotationId: number = 0;
  quotationContract: QuotationModel = new QuotationModel();
  quotationSolutionId: number = 0;
  quotationVersionContract: QuotationVersionModel = new QuotationVersionModel();
  totalsBreakdowns: number = 0;
  updateTableBreakdown: boolean = false;
  userAuthenticated: UserModel = new UserModel();
  versionId: number = 0;


  constructor() {
    this.getAllLists();
    this.getUserAuthenticatedService();
    this.validateForm(new QuotationDetailModel());
  }

  ngOnInit() {
    this.subscription = this.outputCopy$.subscribe(({ type }) => {
      switch (type) {
        case 'updateList':
          this.getQuotationDetailsByVersion();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputImport$.subscribe(({ type }) => {
      switch (type) {
        case 'updateList':
          this.getQuotationDetailById();
          this.updateTableBreakdown = true;
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputMasterSolution$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'quotationDetailId':
          this.quotationSolutionId = payload
          this.getQuotationDetailById();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputAttachImages$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'updateQuotationSolutionModel':
          this.quotationSolutionContract = payload
          this.getQuotationDetailsByVersion();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  calculateTotalsValue(): void {
    const subtotalValue = this.formQuotationSolution.get("subtotalValue")?.value ?? 0;
    const days = this.formQuotationSolution.get("days")?.value ?? 0;
    const ivaRate = this.formQuotationSolution.get("ivaRate")?.value ?? 0;

    const totalValue = subtotalValue * days;
    const ivaValue = totalValue * (ivaRate / 100);
    const totalWithIva = totalValue + ivaValue;

    // helper para redondear a 2 decimales
    const round2 = (val: number) => Math.round((val + Number.EPSILON) * 100) / 100;

    this.formQuotationSolution.patchValue({
      totalValue: round2(totalValue),
      ivaValue: round2(ivaValue),
      totalWithIva: round2(totalWithIva)
    }, { emitEvent: false });
  }


  async createNewSolution() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para crear cotizaciones. Comuníquese con el administrador del sistema.'
      );
      return;
    }
    this.cleanSolution();

  }

  async cleanSolution() {
    this.quotationSolutionId = 0;
    this.quotationSolutionContract = new QuotationDetailModel();
    const unitUnd = this.listUnits.find(x => x.label.includes(UnitCode.unitUnd));
    await this.validateForm(this.quotationSolutionContract);
    this.breakdownsInSolution = false;
    const newSolution: QuotationDetailModel = new QuotationDetailModel();
    const existsNewSolution = this.quotationDetails.find(x => x.quotationDetailId == 0);
    !existsNewSolution ? this.quotationDetails.push(newSolution) : null;
    if (unitUnd) {
      newSolution.unitId = unitUnd.value;
    }
    this.quotationDetailSelected(existsNewSolution ?? newSolution);
  }

  async changeQuotation(quotation: QuotationModel) {
    this.quotationContract = quotation;
    this.quotationId = quotation.quotationId;
    if (this.quotationId != 0) {
      if (this.quotationContract.constructionSiteId != null) {
        await this.getAllCostCenterForSelect(this.quotationContract.constructionSiteId);
      } else {
        this.listCostCenters = [];
      }
    } else {
      this.quotationVersionContract = new QuotationVersionModel();
      this.versionId = 0;
      this.quotationDetails = [];
      this.quotationSolutionContract = new QuotationDetailModel();
      this.selectedQuotationDetail = new QuotationDetailModel();
    }
  }

  async changeQuotationSolutionContract(change: QuotationDetailModel) {
    if (change.quotationDetailId != 0) {
      this.quotationSolutionContract = change;
      this.quotationSolutionId = change.quotationDetailId;
      this.selectedQuotationDetail = change;
      this.validateForm(this.selectedQuotationDetail);
    }
    else {
      await this.cleanSolution();
    }
  }

  async changeQuotationVersion(quotationVersion: QuotationVersionModel) {
    this.quotationVersionContract = quotationVersion;
    this.versionId = quotationVersion.quotationVersionId;
    if (this.versionId != 0) {
      await this.getQuotationDetailsByVersion();
      if (this.quotationDetails.length > 0) {
        const [firstQuotation] = this.quotationDetails;
        this.quotationDetailSelected(firstQuotation);
      } else {
        this.quotationDetails = [];
        this.selectedQuotationDetail = new QuotationDetailModel();
      }
    } else {
      this.quotationDetails = [];
      this.selectedQuotationDetail = new QuotationDetailModel();
    }
  }

  async deleteSolution(hasBreakdown: boolean) {
    if (hasBreakdown) {
      this.toastHandlerService.showToast(
        'warning',
        'No es posible eliminar, la solución tiene despiece.'
      );
      return;
    }
    const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar la solución?');
    if (accepted) {
      try {
        if (this.quotationSolutionContract.quotationDetailId != 0) {
          await firstValueFrom(
            this.quotationSolutionService.deleteQuotationDetail(this.quotationSolutionContract.quotationDetailId)
          );
        } else {
          this.quotationDetails.pop();
        }
        this.toastHandlerService.showToast(
          'success',
          'La solución fue eliminada exitosamente.'
        );
        await this.getQuotationDetailsByVersion();
        if (this.quotationDetails.length > 0) {
          const [firstQuotation] = this.quotationDetails;
          this.quotationDetailSelected(firstQuotation);
        } else {
          this.quotationDetails = [];
          this.selectedQuotationDetail = new QuotationDetailModel();
          this.quotationDetailSelected(new QuotationDetailModel);
        }
        this.updateQuotationDetail.emit(true);
      } catch (error) {
        console.error('Error al eliminar la solución.', error);
      }
    }
  }

  async getAllCostCenterForSelect(constructionSiteId: number) {
    try {
      this.listCostCenters = await firstValueFrom(
        this.quotationSolutionService.getAllCostCenterForSelect(constructionSiteId)
      );
    } catch (error) {
      console.error('Error al buscar la cotización.', error);
    }
  }

  async getAllLists() {
    try {
      const [units, baseValue] = await Promise.all([
        firstValueFrom(this.quotationSolutionService.getAllUnitsForSelect()),
        firstValueFrom(this.quotationSolutionService.getAllBaseValueForSelect()),
      ]);
      this.listUnits = units;
      this.listBaseValue = baseValue;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  getBaseValue(baseValue: number) {
    const quantity = this.formQuotationSolution.get("quantity")?.value ?? 0;
    const swBreakdown = this.formQuotationSolution.get("swBreakdown")?.value;

    if (baseValue == QuotationDetailEnums.UnitValue) {
      const unitValue = this.formQuotationSolution.get("subtotalValue")?.value;
      this.formQuotationSolution.controls["unitValue"].patchValue(unitValue);

      const subtotalValue = unitValue * quantity
      this.formQuotationSolution.controls["subtotalValue"].patchValue(subtotalValue);
    } else {
      const subtotalValue = this.formQuotationSolution.get("unitValue")?.value;
      this.formQuotationSolution.controls["subtotalValue"].patchValue(subtotalValue);

      const unitValue = subtotalValue / quantity;
      this.formQuotationSolution.controls["unitValue"].patchValue(unitValue);
    }
    this.updateControlsByBaseValue(swBreakdown);
    this.calculateTotalsValue();
  }

  async getCostCenter(costCenterId: number | null) {
    const previousCostCenterId = this.quotationSolutionContract.costCenterId;
    if (previousCostCenterId === costCenterId) {
      return;
    }

    if (costCenterId) {
      this.formQuotationSolution.controls["costCenterId"].patchValue(costCenterId);
    } else {
      if (this.quotationSolutionContract.swBreakdown) {
        this.toastHandlerService.showToast(
          'warning',
          'No es posible limpiar el c.costos, la solución tiene despiece.'
        );
        return;
      }
      this.formQuotationSolution.controls["costCenterId"].patchValue(null);
    }
  }


  getQuantity(quantity: number) {
    const baseValue = this.formQuotationSolution.get("baseValue")?.value;

    if (baseValue == QuotationDetailEnums.UnitValue) {
      const unitValue = this.formQuotationSolution.get("unitValue")?.value;
      const subtotalValue = unitValue * quantity
      this.formQuotationSolution.controls["subtotalValue"].patchValue(subtotalValue);
    } else {
      const subtotalValue = this.formQuotationSolution.get("subtotalValue")?.value;
      const unitValue = subtotalValue / quantity
      this.formQuotationSolution.controls["unitValue"].patchValue(unitValue);
    }

    this.calculateTotalsValue();
  }

  async getTotalBreakdown(quotationSolutionId: number) {
    const totalsBreakdowns = await firstValueFrom(
      this.breakdownService.getTotalBreakdownByQuotationDetailId(quotationSolutionId)
    );
    return totalsBreakdowns;
  }

  async getUserAuthenticatedService() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(
      this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.Quotation)
    );
  }

  getSolutionName(label: string | null): string {
    if (!label) return '';
    if (label.length > 30) {
      return `${label.slice(0, 30 - 3)}...`;
    }
    return label;
  }

  async getQuotationDetailsByVersion() {
    if (this.versionId != 0) {
      try {
        const response = await firstValueFrom(this.quotationSolutionService.getQuotationDetailsByVersionId(this.versionId));
        this.quotationDetails = response;
        this.quotationDetails.forEach(async detail => {
          if (detail.costCenterId != null) {
            detail.costCenterCodeName = this.listCostCenters.find(x => x.value == detail.costCenterId)?.label;
          }
        });
      } catch (error) {
        console.error('Error al obtener las soluciones por id.', error);
      }
    }
  }

  async getQuotationDetailById() {
    try {
      this.quotationSolutionContract = await firstValueFrom(
        this.quotationSolutionService.getQuotationDetailById(this.quotationSolutionId)
      );
      this.quotationSolutionId = this.quotationSolutionContract.quotationDetailId;
      await this.getQuotationDetailsByVersion();
      await this.validateForm(this.quotationSolutionContract);

    } catch (error) {
      console.error('Error al buscar la cotización.', error);
    }
  }

  getSubtotalValue(subtotalValue: number) {
    const quantity = this.formQuotationSolution.get("quantity")?.value;
    const unitValue = subtotalValue * quantity;
    this.formQuotationSolution.controls["unitValue"].patchValue(unitValue);
    this.calculateTotalsValue();
  }

  async getSwBreakdown(swBreakdown: boolean) {
    if (swBreakdown) {
      setTimeout(() => this.formControlStateService.setControlState(this.formQuotationSolution, ['unitValue', 'subtotalValue'], false), 100);
    } else {
      this.totalsBreakdowns = await this.getTotalBreakdown(this.quotationSolutionId);
      if (this.totalsBreakdowns > 0) {
        this.formQuotationSolution.controls["swBreakdown"].patchValue(true);
        this.toastHandlerService.showToast(
          'warning',
          `No es posible cambiar el despiece. La solución tiene artículos relacionados.`
        );
        return;
      }
      this.updateControlsByBaseValue(swBreakdown);
    }
  }

  getUnitValue(unitValue: number) {
    const quantity = this.formQuotationSolution.get("quantity")?.value;
    const subtotalValue = unitValue * quantity;
    this.formQuotationSolution.controls["subtotalValue"].patchValue(subtotalValue);
    this.calculateTotalsValue();
  }

  openImportBreakdown() {
    const userImport = this.permissionsUser.find(x => x.code != OptionWindow.Importar);
    if (this.userAuthenticated.profileUser.code != ProfileUserEnums.administrador
      || userImport || !this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para importar Despiece de Solución, comuniquese con el administrador del sistema.'
      );
      return;
    }

    if (!this.quotationSolutionContract.swBreakdown) {
      this.toastHandlerService.showToast(
        'warning',
        'La solución seleccionada NO tiene activo el campo de despiece.'
      );
      return;
    }

    if (this.breakdownsInSolution) {
      this.toastHandlerService.showToast(
        'warning',
        'No es posible importar. Existen artículos agregados al despiece.'
      );
      return;
    }

    this.updateImportInputs();
    this.importModalComponent && this.importModalComponent.show();
  }

  openCompositeArticle() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para importar desde artículos compuestos, comuniquese con el administrador del sistema.'
      );
      return;
    }
    if (this.breakdownsInSolution) {
      this.toastHandlerService.showToast(
        'warning',
        'No es posible desde artículos compuestos. Existen artículos agregados al despiece.'
      );
      return;
    }
    this.inputsForMasterSolution$.next({
      quotationSolutionModel: this.quotationSolutionContract,
      quotationVersionId: this.versionId
    });
    this.compositeArticleModalComponent?.show();
  }

  openAttachImages() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para adjuntar Imágenes, comuniquese con el administrador del sistema.'
      );
      return;
    }

    this.updateAttachImagesInputs();
    this.attachImagesModalComponent && this.attachImagesModalComponent.show();
  }

  openCopyQuotation() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para copiar cotizaciones, comuniquese con el administrador del sistema.', 'Atención');
      return;
    }
    this.updateCopyInputs();
    this.copyQuotationModalComponent && this.copyQuotationModalComponent.show();
  }

  updateCopyInputs() {
    this.inputsForCopy$.next({
      quotationVersion: this.quotationVersionContract,
      quotationType: this.quotationContract.quotationTypeId
    });
  }

  quotationDetailSelected(selected: QuotationDetailModel) {
    this.quotationSolutionId = selected.quotationDetailId;
    this.selectedQuotationDetail = selected;
    this.quotationSolutionContract = selected;
    this.validateForm(this.quotationSolutionContract);
  }

  async send() {
    Object.keys(this.formQuotationSolution.controls).forEach(key => {
      const control = this.formQuotationSolution.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });

    if (this.formQuotationSolution.valid) {
      const modelQuotationSolution = this.formQuotationSolution.getRawValue();
      if (typeof (this.quotationSolutionContract.costCenterId) == 'string') {
        this.toastHandlerService.showToast(
          'warning',
          'El centro de costos no es válido. Verifique que exista en la lista de centros de costos.'
        );
        return;
      }

      if (modelQuotationSolution.costCenterId === '') modelQuotationSolution.costCenterId = null;

      if (this.quotationSolutionId == 0) {
        modelQuotationSolution.quotationId = this.quotationId;
        modelQuotationSolution.quotationVersionId = this.versionId;
        try {
          this.quotationSolutionContract = await firstValueFrom(
            this.quotationSolutionService.createQuotationDetail(modelQuotationSolution)
          );
          this.toastHandlerService.showToast(
            'success',
            'La solución fue creada exitosamente'
          );
          this.quotationSolutionId = this.quotationSolutionContract.quotationDetailId;
          await this.validateForm(this.quotationSolutionContract);
        } catch (error) {
          console.error('Error al crear la solución.', error);
        }
      } else {

        this.quotationSolutionContract.costCenterId = modelQuotationSolution.costCenterId;
        this.quotationSolutionContract.solutionCode = modelQuotationSolution.solutionCode;
        this.quotationSolutionContract.solutionName = modelQuotationSolution.solutionName;
        this.quotationSolutionContract.swBreakdown = modelQuotationSolution.swBreakdown;
        this.quotationSolutionContract.baseValue = modelQuotationSolution.baseValue;
        this.quotationSolutionContract.unitId = modelQuotationSolution.unitId;
        this.quotationSolutionContract.unitValue = modelQuotationSolution.unitValue;
        this.quotationSolutionContract.quantity = modelQuotationSolution.quantity;
        this.quotationSolutionContract.subtotalValue = modelQuotationSolution.subtotalValue;
        this.quotationSolutionContract.days = modelQuotationSolution.days;
        this.quotationSolutionContract.totalValue = modelQuotationSolution.totalValue;
        this.quotationSolutionContract.ivaRate = modelQuotationSolution.ivaRate;
        this.quotationSolutionContract.ivaValue = modelQuotationSolution.ivaValue;
        try {
          this.quotationSolutionContract = await firstValueFrom(
            this.quotationSolutionService.updateQuotationDetail(this.quotationSolutionContract)
          );
          this.toastHandlerService.showToast(
            'success',
            'La solución fue modificada exitosamente'
          );
          await this.validateForm(this.quotationSolutionContract);
        } catch (error) {
          console.error('Error al actualizar la solución.', error);
        }
      }
      await this.getQuotationDetailsByVersion();
      await this.quotationDetailSelected(this.quotationSolutionContract);
      this.updateQuotationDetail.emit(true);
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      solutionCode: {
        required: 'El campo solución es obligatorio.'
      },
      baseValue: {
        required: 'El campo valor base es obligatorio.',
        min: 'Debe seleccionar al menos un valor base.'
      },
      unitId: {
        required: 'El campo unidad es obligatorio.',
        min: 'Debe seleccionar al menos una unidad.'
      },
      quantity: {
        required: 'El campo cantidad es obligatorio.',
        min: 'Debe ingresar mínimo una cantidad.'
      },
      days: {
        required: 'El campo días es obligatorio.',
        min: 'Debe ingresar mínimo un día.'
      },
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formQuotationSolution.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  private updateControlsByBaseValue(swBreakdown: boolean): void {
    const baseValue = this.formQuotationSolution.get("baseValue")?.value;

    const [enable, disable] = baseValue === QuotationDetailEnums.UnitValue
      ? ['unitValue', 'subtotalValue'] : ['subtotalValue', 'unitValue'];
    Promise.resolve().then(() => {
      this.formControlStateService.setControlState(this.formQuotationSolution, [disable], false);
      this.formControlStateService.setControlState(this.formQuotationSolution, [enable], swBreakdown ? false : true);
    });
  }

  updateImportInputs() {
    this.inputsForImport$.next({
      quotationSolutionModel: this.quotationSolutionContract,
      breakdownsInSolution: this.breakdownsInSolution
    });
  }

  updateAttachImagesInputs() {
    this.inputsForAttachImages$.next({
      quotationSolutionModel: this.quotationSolutionContract,
    });
  }

  validateForm(quotationSolution: QuotationDetailModel) {
    this.formQuotationSolution = this.formBuilder.group({
      quotationId: [quotationSolution.quotationId, []],
      quotationVersionId: [quotationSolution.quotationVersionId, []],
      quotationDetailId: [quotationSolution.quotationDetailId, []],
      costCenterId: [quotationSolution.costCenterId, []],
      solutionCode: [quotationSolution.solutionCode, [Validators.required]],
      solutionName: [quotationSolution.solutionName, []],
      swBreakdown: [quotationSolution.swBreakdown, []],
      baseValue: [quotationSolution.baseValue, [Validators.required, Validators.min(1)]],
      unitId: [quotationSolution.unitId, [Validators.required, Validators.min(1)]],
      unitValue: [quotationSolution.unitValue, []],
      quantity: [quotationSolution.quantity, [Validators.required, Validators.min(1)]],
      subtotalValue: [quotationSolution.subtotalValue, []],
      days: [quotationSolution.days, [Validators.required, Validators.min(1)]],
      totalValue: [quotationSolution.totalValue, []],
      ivaRate: [quotationSolution.ivaRate, []],
      ivaValue: [quotationSolution.ivaValue, []],
      totalWithIva: [quotationSolution.totalValue + quotationSolution.ivaValue]
    });
    this.formControlStateService.setControlState(this.formQuotationSolution, ['totalValue', 'ivaValue', 'totalWithIva'], false);
    this.updateControlsByBaseValue(quotationSolution.swBreakdown);
    this.formQuotationSolution[!this.quotationVersionContract.active ? 'disable' : 'enable']();
  }
}
